import { HttpContextToken } from '@angular/common/http';

export const SHOW_SUCCESS_TOAST = new HttpContextToken(() => false);
export const SHOW_ERROR_TOAST = new HttpContextToken(() => true);
export const CUSTOM_SUCCESS_MESSAGE = new HttpContextToken<string | null>(() => null);